import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/products/courier/components/CourierContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Header.tsx");
